
<pbir-visual-style-editor [busy]="busy()" [visual]="visual()">
  <ng-container styleAfter>
    <visual-editor-box appearance="fields" canCollapse>
      <span boxTitle>
        <i class="far fa-text-size w-16 text-center mr-5"></i>
        <span>Measure</span>
      </span>
      <div>
        <visual-title-style-editor [(style)]="measure" [fontSelectionDisabled]="true">
          <ng-container textAfter>
            <label>Number Format:</label>
            <mat-select class="h-24 trg-outline user-select-none" panelClass="trg-outline-dropdown"
                        [disabled]="busy()"
                        [value]="numberFormat()"
                        (valueChange)="setValue(numberFormat, $event)">
              @for (nf of numberFormats; track nf.id) {
              <mat-option [value]="nf.id">{{nf.title}}</mat-option>
              }
            </mat-select>
          </ng-container>
        </visual-title-style-editor>
      </div>
    </visual-editor-box>
  </ng-container>
</pbir-visual-style-editor>